import { getCountryCode } from "./helpers/countryHelper/countryHelper";

const configs = require("./config.json");
const countryCode = getCountryCode();

export const AppConfig = {
  countryCode,
  user_simulator_tranking_api: configs.SIMULATOR_API_URL || 'https://transference-simulator-api.autofact.qa/v1/',
  autofact_real_price: configs.AUTOFACT_TRANSFERENCE_REAL_PRICE || 0,
  civil_register_price: configs.CIVIL_REGISTER_PRICE || 0,
  individual_sign_price: configs.TRANSFERENCE_INDIVIDUAL_SIGN_PRICE || 0,
  dsct_code: configs.DISCOUNT_CODE,
  cta_url: configs.CTA_URL_BASE || 'https://cl.compra.autofact.qa/transferencia-prepago',
  arancel: Number(configs.REACT_APP_ARANCEL || '36030'),
};

export const TagManagerCodesConfig: any = {
  cl: configs.REACT_APP_GMT_CL || "GTM-NM62MBM",
};